import Dropdown from 'react-bootstrap/Dropdown'
import "react-dropdown/style.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import { showDangerToast } from "../../constants/toaster";
import { s3 } from "../../constants/awsConfig";
import { useDispatch, useSelector } from "react-redux";
import { updateLoading } from "../../../redux/features/common/commonSlice";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

export const AddRadio = (props) => {
    const dispatch = useDispatch()
    const [imageFile, setImageFile] = useState(null);
    const [image, setImage] = useState(null);
    const userData = useSelector(state => state?.userData)
    const [categoryDropdownDataList, setCategoryDropdownDataList] = useState([])
    const [typeDropdownText, setTypeDropdownText] = useState({
        id: null,
        value: 'Select Category'
    })

    useEffect(() => {
        if (props?.show) {
            console.log(props?.radioFormData)
            getCategoryList()
        }
    }, [props.show]);

    const uploadFileToAWS = async (selectedFile) => {
        if (!selectedFile) return;

        const params = {
            Bucket: 'supa-dev-bucket', // bucket name
            Key: `uploads/${selectedFile.name}`,
            Body: selectedFile,
            ContentType: selectedFile.type,
            // ACL: 'public-read', // Adjust according to your needs
        };

        try {
            const data = await s3.upload(params).promise();
            const url = data.Location.replace(
                "https://supa-dev-bucket.s3.af-south-1.amazonaws.com/",
                "https://d2up68x544gew2.cloudfront.net/"
            );
            return { success: true, url: url }
        } catch (error) {
            console.error('Error uploading file:', error);
            return { success: false }
        }
    };

    const getCategoryList = async () => {
        try {
            dispatch(updateLoading(true))
            let path = urls.liveReelCategoryKeyValuePair
            let postJson = {
                name: '',
                type: 'ALL'
            }
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                console.log(response?.data)
                let tempArray = [{
                    id: null,
                    value: 'Select Category'
                }]
                for (let i = 0; i < response?.data?.length; i++) {
                    tempArray.push({
                        id: response?.data?.[i]?.id,
                        value: response?.data?.[i]?.name
                    })
                    if (props?.radioFormData?.categoryId === response?.data[i]?.id) {
                        setTypeDropdownText({
                            id: response?.data?.[i]?.id,
                            value: response?.data?.[i]?.name
                        })
                    }
                }
                setCategoryDropdownDataList(tempArray)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleSubmit = async () => {
        let validateSuccess = false;
        if (props?.radioFormData?.id) {
            if (
                props?.radioFormData?.title &&
                props?.radioFormData?.description &&
                props?.radioFormData?.thumbnail &&
                props?.radioFormData?.categoryId &&
                props?.radioFormData?.playBackUrl &&
                props?.radioFormData?.accessType &&
                props?.radioFormData?.mediaType
            ) {
                if (props?.radioFormData?.accessType === 'PAID') {
                    if (props?.radioFormData?.amount) {
                        validateSuccess = true;

                    } else {
                        showDangerToast("Please fill all required Fields.");
                        validateSuccess = false;
                    }
                } else {
                    validateSuccess = true;
                }

                if (validateSuccess) {
                    if (imageFile) {
                        dispatch(updateLoading(true));
                        const isImageUploaded = await uploadFileToAWS(imageFile);
                        dispatch(updateLoading(false));
                        if (isImageUploaded.success) {
                            props.onSubmit(isImageUploaded.url);
                        } else {
                            showDangerToast("Image upload failed.");
                        }
                    } else {
                        props.onSubmit(props?.radioFormData?.thumbnail);
                    }
                }
            } else {
                showDangerToast("Please fill all required Fields.");
            }
        } else {
            if (
                props?.radioFormData?.title &&
                props?.radioFormData?.description &&
                props?.radioFormData?.categoryId &&
                props?.radioFormData?.playBackUrl &&
                props?.radioFormData?.accessType &&
                props?.radioFormData?.mediaType &&
                imageFile
            ) {
                if (props?.radioFormData?.accessType === 'PAID') {
                    if (props?.radioFormData?.amount) {
                        validateSuccess = true;
                    } else {
                        showDangerToast("Please fill all required Fields.");
                        validateSuccess = false;
                    }
                } else {
                    validateSuccess = true;
                }
            } else {
                showDangerToast("Please fill all required Fields.");
                validateSuccess = false;
            }
            if (validateSuccess) {
                dispatch(updateLoading(true));
                const isImageUploaded = await uploadFileToAWS(imageFile);
                dispatch(updateLoading(false));
                if (isImageUploaded.success) {
                    props.onSubmit(isImageUploaded.url);
                    console.log(isImageUploaded.url)
                } else {
                    showDangerToast("Image upload failed.");
                }
            }
        }
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImageFile(file);
            // props?.setradioFormData({
            //     ...props?.radioFormData,
            //     thumbnail: ''
            // })
            setImage(URL.createObjectURL(file));
        }
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props?.radioFormData?.id ? "Update Radio" : "Add Radio"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6">
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    value={props.radioFormData?.title}
                                    onChange={(e) =>
                                        props.setRadioFormData({
                                            ...props?.radioFormData,
                                            title: e.target.value,
                                        })
                                    }
                                    placeholder="Title"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                />
                            </div>
                        </Form.Group>

                    </div>
                    <div className="col-md-6">
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Select Category</Form.Label>
                                <Dropdown>
                                    <Dropdown.Toggle
                                        variant='success'
                                        style={{
                                            backgroundColor: 'white',
                                            color: 'black',
                                            border: '1px solid #cad1d7',
                                            boxShadow: 'none',
                                            transform: 'none'
                                        }}
                                        id='dropdown-basic'
                                    >
                                        {typeDropdownText?.value}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {categoryDropdownDataList?.map((data, i) => {
                                            return <>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        setTypeDropdownText(data)
                                                        props.setRadioFormData({
                                                            ...props?.radioFormData,
                                                            categoryId: data?.id,
                                                        })
                                                    }
                                                    }
                                                >
                                                    {data?.value}
                                                </Dropdown.Item>
                                            </>
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </Form.Group>

                    </div>
                    <div className="col-md-6 mt-2">
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Choose Media Type</Form.Label>
                                <RadioGroup
                                    row
                                    value={props?.radioFormData?.mediaType}
                                    onChange={(e) => props.setRadioFormData({
                                        ...props?.radioFormData,
                                        mediaType: e.target.value,
                                    })}
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="AUDIO" control={<Radio />} label="Audio" />
                                    <FormControlLabel value="VIDEO" control={<Radio />} label="Video" />
                                </RadioGroup>
                            </div>
                        </Form.Group>
                    </div>
                    <div className="col-md-6 mt-2">
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Choose Access Type</Form.Label>
                                <RadioGroup
                                    row
                                    value={props?.radioFormData?.accessType}
                                    onChange={(e) => props.setRadioFormData({
                                        ...props?.radioFormData,
                                        accessType: e.target.value,
                                    })}
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="FREE" control={<Radio />} label="Free" />
                                    <FormControlLabel value="PAID" control={<Radio />} label="Paid" />
                                    <FormControlLabel value="SUBSCRIBER_ONLY" control={<Radio />} label="Subscriber Only" />
                                </RadioGroup>
                            </div>
                        </Form.Group>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Choose Thumbnail</Form.Label>
                                <input type="file" accept="image/*" onChange={handleImageChange} />
                            </div>
                        </Form.Group>
                        <div>
                            {props?.radioFormData?.thumbnail ? <img src={props?.radioFormData?.thumbnail} style={{ maxWidth: "200px", maxHeight: '200px', marginTop: "10px" }}></img> : <img src={image} style={{ maxWidth: "200px", maxHeight: '200px', marginTop: "10px" }}></img>}
                        </div>

                    </div>
                    {props?.radioFormData?.accessType && props?.radioFormData?.accessType === 'PAID' ?
                        <div className="col-md-6 mt-2">
                            <Form.Group controlId='exampleForm.ControlInput1'>
                                <div style={{ display: 'grid' }}>
                                    <Form.Label>Enter Amount</Form.Label>
                                    <Form.Control
                                        value={props.radioFormData?.amount}
                                        onChange={(e) =>
                                            props.setRadioFormData({
                                                ...props?.radioFormData,
                                                amount: e.target.value,
                                            })
                                        }
                                        placeholder="0.0"
                                        aria-label="Small"
                                        aria-describedby="inputGroup-sizing-sm"
                                    />
                                </div>
                            </Form.Group>
                        </div> : <></>}

                    <div className="col-md-12 mt-2">
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Radio Link</Form.Label>
                                <Form.Control
                                    value={props.radioFormData?.playBackUrl}
                                    onChange={(e) =>
                                        props.setRadioFormData({
                                            ...props?.radioFormData,
                                            playBackUrl: e.target.value,
                                        })
                                    }
                                    placeholder="Radio Link"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="col-md-12 mt-2">
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    value={props.radioFormData?.description}
                                    onChange={(e) =>
                                        props.setRadioFormData({
                                            ...props?.radioFormData,
                                            description: e.target.value,
                                        })
                                    }
                                    as="textarea" rows={3}
                                    placeholder="Description"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                />
                            </div>
                        </Form.Group>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outlined" onClick={props.onHide}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
};
